/*! @azure/msal-common v14.8.1 2024-03-27 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.8.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
